import { useEffect } from 'react';
import { usePathname } from 'next/navigation';

const useAppEffects = () => {
	const pathName = usePathname();

	useEffect(() => {
		(async () => {
			setTimeout(() => {
				document.body.style.cursor = 'default';
				window.scrollTo(0, 0);
			}, 2000);
		})();
	}, [pathName]);



	useEffect(() => {
		const setVhProperty = () => {
			const vh = window.innerHeight * 0.01;
			document.documentElement.style.setProperty('--vh', `${vh}px`);
		};
		setVhProperty();
		window.addEventListener('resize', setVhProperty);
		return () => window.removeEventListener('resize', setVhProperty);
	}, []);

	useEffect(() => {
		if ('serviceWorker' in navigator) {
			navigator.serviceWorker
				.register('/sw.js')
				.catch(error => {
					console.error('Service Worker registration failed:', error);
				});
		}
	}, []);
};

export default useAppEffects;
